import React from 'react';
import { TextField } from '../../components/AtomComponents';
import { Tooltip } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';
import type { TenantStepData } from './types';
import { StepCard, StepField, StepHeader, StepFormContainer } from './PxwStepComponents';

interface TenantStepProps {
  data: TenantStepData;
  onChange: (data: TenantStepData) => void;
}

const TenantStep = ({ data, onChange }: TenantStepProps) => (
  <StepCard>
    <StepHeader title="Tenant" subtitle="PXW Connector setup — configure the tenant and gateway details" />
    <StepFormContainer>
      <div className="grid-x">
        <div className="small-12 medium-6 large-4 margin-bottom-2">
          <StepField
            label={
              <span>
                Tenant ID
                <Tooltip title="saas tenant id" arrow placement="top" classes={{ popper: 'pxw-tooltip-popper' }}>
                  <HelpOutline className="pxw-info-icon" />
                </Tooltip>
              </span>
            }
          >
            <TextField
              size="small"
              fullWidth
              required
              name="tenantId"
              placeholder="e.g. acmewireless"
              value={data.tenantId}
              onChange={(e) => onChange({ ...data, tenantId: e.target.value.trim() })}
              inputProps={{ maxLength: 100 }}
            />
          </StepField>
        </div>

        <div className="small-12 margin-bottom-2">
          {/* Note: Gateway base URL is non-editable and dynamically resolved based on environment variables (REACT_APP_CONNECTOR_GATEWAY_URL) */}
          <StepField label="Connector Maintenance API Gateway base URL" wide>
            <TextField
              size="small"
              fullWidth
              disabled
              name="gatewayBaseUrl"
              value={data.gatewayBaseUrl}
              inputProps={{ maxLength: 500 }}
            />
          </StepField>
        </div>
      </div>
    </StepFormContainer>
  </StepCard>
);

export default TenantStep;
